// index.js
// Root reducer

// Imports
import { combineReducers } from 'redux';
import { clientReducer } from './client';
import { productReducer } from './product';
import { orderReducer } from './order';

// Reducers
const rootReducer = combineReducers({
  client: clientReducer,
  product: productReducer,
  order: orderReducer,
});

// Exports
export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js